import { useField } from 'formik';

import { Input, InputProps } from '../Input/Input';

interface InputFieldProps extends InputProps {
  name: string;
}

export function InputField({ name, inputProps, ...rest }: InputFieldProps) {
  const [field, meta] = useField(name);
  const showError = meta.touched && Boolean(meta.error);

  return (
    <Input
      {...rest}
      error={showError ? meta.error : ''}
      inputProps={{
        ...inputProps,
        ...field,
        onChange: (e) => {
          field.onChange(e);
          inputProps?.onChange?.(e);
        },
      }}
    />
  );
}
